import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import wrapReact from '../../util/react';
import { updateLanguage } from '../../util/intl';
import { wrapFunc } from '../../util/js';
import { actLogout } from '../../redux/action';
import { CB_STATUS } from '../../util/fetch/cFetch';
import { actGetUser, actUpdateUser } from '../../redux/action/user';

export default function CompWrapper(Comp, name) {
  class wrapComp extends Component {
    changeLanguage = wrapFunc((key) => {
      const { dispatch } = this.props;
      console.log('changeLanguage');
      updateLanguage(dispatch, key);
    }, 'changeLanguage');

    handleLogout = wrapFunc(() => {
      const { dispatch } = this.props;
      actLogout(dispatch);
    }, 'handleLogout');

    updateUser = wrapFunc((data, cb) => {
      const {
        user, auth, intl, dispatch,
      } = this.props;
      const callback = (res) => {
        actGetUser(dispatch, {
          email: user.email,
          token: auth.token,
          lang: intl.locale,
        });
        if (cb) cb(res);
        if (res.status === CB_STATUS.SUCCESS && data.password) {
          this.handleLogout();
        }
      };
      actUpdateUser(dispatch,
        {
          email: user.email,
          lang: intl.locale,
          token: auth.token,
          password: data.password,
          current_password: data.current_password,
          firstName: data.firstName,
          lastName: data.lastName,
        },
        callback);
    }, 'changePwd');

    render() {
      const { ui, dispatch } = this.props;
      return (
        <Comp
          {...this.props}
          ui={ui}
          changeLanguage={this.changeLanguage}
          handleLogout={this.handleLogout}
          updateUser={this.updateUser}
          dispatch={dispatch}
        />
      );
    }
  }
  wrapComp.propTypes = {
    ui: PropTypes.object.isRequired,
    user: PropTypes.shape({
      email: PropTypes.string.isRequired,
    }).isRequired,
    auth: PropTypes.shape({
      token: PropTypes.string.isRequired,
    }).isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string.isRequired,
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
  };
  function mapStateToProps(state) {
    return {
      ui: state.get('ui').uiIndex,
      auth: state.get('auth'),
      user: state.get('user'),
    };
  }
  return connect(mapStateToProps)(wrapReact(wrapComp, name));
}
